import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import { Redirect } from "react-router-dom";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceReferencePositionEdit from "../EssenceReferencePositionEdit";

export default class StaffAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      currentArea: {},
      pending: false,
      cancel: false,
      redirect: false,
      position: null,
      data: {
        nouser: false,
        typecode: "",
        phone: { mobile: "" },
      },
      emails: [""],
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });
    let types = await this.context.api.qo("/staff/type");
    let currentArea = await this.context.user.currentGet("area");
    this.setState({ types, currentArea, pending: false });
  };

  addEmail = () => {
    let emails = this.state.emails;
    emails.push("");
    this.setState({ emails });
  };

  onChangeEmails = (index, value) => {
    let emails = this.state.emails;
    emails[index] = value;
    this.setState({ emails });
  };

  onChange = (e) => {
    let data = this.state.data;
    const id = e.target.id;
    const value = e.target.id === "nouser" ? e.target.checked : e.target.value;

    if (id.indexOf(".") > 0) {
      let ids = id.split(".");
      data[ids[0]][ids[1]] = value;
    } else {
      data[id] = value;
    }
    this.setState({ data });
  };

  cancel = () => {
    this.setState({ pending: true, cancel: true });
  };

  save = async () => {
    const data = this.state.data;
    let emails = [];
    this.state.emails.forEach((email) => {
      if (email.trim()) emails.push(email);
    });

    let nameArray = [];
    if (data.lastname) nameArray.push(data.lastname);
    if (data.firstname) nameArray.push(data.firstname);
    if (data.middlename) nameArray.push(data.middlename);

    let fullName =
      data.typecode === "physical.staff" || data.typecode === "individual.staff"
        ? nameArray.join(" ")
        : data.fullname;

    let phone = data.phone;
    if (!phone.mobile) phone.mobile = null;

    let saveData = {
      id: data.id,
      type: this.context.getType(data.typecode) || null,
      email: emails || null,
      phone: phone,
      code: data.code || null,
      description: data.description || null,
      userid: data.nouser ? null : this.context.api.nullUuid,
      position: this.state.position || null,
      name: {
        name: fullName || "",
        first: data.firstname || "",
        last: data.lastname || "",
        middle: data.middlename || "",
      },
    };

    this.setState({ pending: true });
    let result = await this.context.api.q("/staff/set", saveData);
    if (result !== false) {
      this.context.toast("Профиль сотрудника сохранен", "success");
      if (result.id) {
        this.setState({ redirect: `/staff/${result.id}/` });
      } else {
        this.setState({ cancel: true });
      }
    } else {
      this.context.toast("Не удалось сохранить профиль сотрудника", "error");
      this.setState({ pending: false });
    }
  };

  onSelectPosition = (position) => {
    this.setState({ position });
  };

  render() {
    let data = this.state.data;
    let types = this.state.types || {};

    const { currentArea = {} } = this.state;

    if (this.state.cancel) {
      return <Redirect to="/staff/" />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <>
        <div className="d-flex justify-content-center">
          <div className="card card-custom col-lg-6">
            <div className="card-header">
              <div className="card-title">
                <h3 className="card-label">Добавление сотрудника</h3>
              </div>
            </div>
            <div className="card-body">
              <Blocker on={this.state.pending}>
                <div className="form-group">
                  <label>Тип:</label>
                  <select
                    className="form-control"
                    id="typecode"
                    onChange={(e) => this.onChange(e)}
                    value={data.typecode}
                  >
                    <option></option>
                    {Object.entries(types).map(([id, type]) => (
                      <option key={id} value={type.code}>
                        {type.description}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Должность:</label>

                  <SuperSelect
                    defaultValue={this.state.position}
                    onChange={(value) => this.onSelectPosition(value)}
                    essence="position"
                    placeholder="Выберите должность..."
                    nameField="name"
                    idField="id"
                    reference={{
                      title: "Должности",
                      essence: "position",
                      showDescription: true,
                      showType: true,
                      itemEditor: (itemEditorProps) => (
                        <EssenceReferencePositionEdit {...itemEditorProps} />
                      ),
                    }}
                  />
                </div>

                <div className="form-group">
                  <label>Логин:</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    value={data.code}
                    id="code"
                    onChange={(e) => this.onChange(e)}
                  />
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Фамилия:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.lastname}
                        id="lastname"
                        onChange={(e) => this.onChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Имя:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.firstname}
                        id="firstname"
                        onChange={(e) => this.onChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Отчество:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.middlename}
                        id="middlename"
                        onChange={(e) => this.onChange(e)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Телефон:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.phone ? data.phone.mobile : ""}
                        id="phone.mobile"
                        onChange={(e) => this.onChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <div className="d-flex justify-content-between">
                        <label>E-mail:</label>
                        <span
                          onClick={() => this.addEmail()}
                          title="Добавить Email"
                          className="cursor-pointer  flaticon2-add-1 text-muted text-hover-primary"
                        ></span>
                      </div>
                      {this.state.emails.map((email, index) => (
                        <input
                          type="text"
                          className="form-control mb-3"
                          value={email}
                          onChange={(e) =>
                            this.onChangeEmails(index, e.target.value)
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Описание:</label>
                  <textarea
                    type="text"
                    className="form-control mb-3"
                    value={data.description}
                    id="description"
                    onChange={(e) => this.onChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label className="checkbox">
                    <input
                      id="nouser"
                      onChange={(e) => this.onChange(e, e.target.checked)}
                      checked={data.nouser ? true : false}
                      type="checkbox"
                    />
                    <span className="mr-4"></span>
                    Создать сотрудника без доступа к системе
                  </label>
                </div>
                <div className="alert bg-light-primary">
                  <i className="fa fa-info   mr-2"></i>Вы добавленияете
                  сотрудника в подразделение:
                  <br /> <b>{currentArea.name}</b>
                </div>
                <div className="form-group">
                  <button
                    onClick={() => this.save()}
                    className="btn btn-primary mr-2"
                  >
                    Сохранить
                  </button>
                  <button
                    onClick={() => this.cancel()}
                    className="btn btn-light"
                  >
                    Отмена
                  </button>
                </div>
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
